import React from "react";
import styles from "./CounterNoInput.module.css";
import { useSelector, useDispatch } from "react-redux";
import {
  addItemToCart,
  removeItemFromCart,
  removeOneFromCart,
} from "../../redux/userSlice";
import { useState } from "react";

function CounterNoInput({ product }) {
  const products = useSelector((state) => state.products);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const handleClickMinus = () => {
    if (product.qty === 1) {
      return dispatch(removeItemFromCart({ name: product.name }));
    } else if (product.qty > 1) {
      return dispatch(removeOneFromCart({ name: product.name }));
    }
  };

  const itemInStock = products.find((item) => item.name === product.name);

  const handleClickPlus = () => {
    if (itemInStock.stock === product.qty) {
      return setError(
        `Lo sentimos, solamente hay ${itemInStock.stock} en stock.`
      );
    } else {
      setError(null);
      return dispatch(
        addItemToCart({
          name: product.name,
          qty: 1,
        })
      );
    }
  };

  return (
    <>
      <div className="d-flex">
        <div className={styles.btns + " d-flex align-items-center me-1"}>
          <button
            type="button"
            className={styles.btn + " text-white"}
            onClick={() => handleClickMinus()}
          >
            -
          </button>
        </div>

        <div className={styles.btns + " d-flex align-items-center"}>
          <button
            className={styles.btn + " text-white"}
            type="button"
            onClick={() => handleClickPlus()}
          >
            +
          </button>
        </div>
      </div>
    </>
  );
}

export default CounterNoInput;
